import { Flex, Heading, Button, Icon, Text } from "@chakra-ui/react";
import { FaPlus } from "react-icons/fa";
import { white, primaryAlt, textPrimary, newBorder } from "../../utils/colors";
// import SubscriptionLimitButtonWrapper from "../widgets/SubscriptionLimitButtonWrapper";
import useIsMobile from "../../hooks/useIsMobile";

const PageHeader = ({ label, filter, buttonHandler, buttonLabel }) => {
  const isMobile = useIsMobile();

  return (
    <Flex
      w="100%"
      direction="column"
      p={["0rem 1.5rem", "0rem 2rem"]}
      m="0 0 0rem"
    >
      <Flex
        w="100%"
        align="center"
        justify="space-between"
        borderBottom={`0px solid ${newBorder}`}
        p="1.25rem 0rem 0.5rem"
      >
        <Heading fontSize={["1.125rem", "1.25rem"]} fontWeight="600">
          {label}
        </Heading>

        <Flex align="center" justify="flex-end" gap={["0.5rem", "0.75rem"]}>
          {filter}
          {/* <SubscriptionLimitButtonWrapper moduleName="treatmentPlans">   */}
          <Button
            size={["md", "lg"]}
            borderRadius="100rem"
            bg={textPrimary}
            color={white}
            p={["1rem 1rem", "1rem 1.5rem"]}
            onClick={buttonHandler}
            _hover={{ bg: primaryAlt, color: white }}
          >
            <Icon
              as={FaPlus}
              mr={["0rem", "0.5rem"]}
              fontSize="0.875rem"
              opacity="1"
            />
            {!isMobile && <Text fontSize="md">{buttonLabel}</Text>}
          </Button>
          {/* </SubscriptionLimitButtonWrapper> */}
        </Flex>
      </Flex>
    </Flex>
  );
};

export default PageHeader;
